import React from 'react';
import Hero from '../layout/hero';
import { useLocation } from '@gatsbyjs/reach-router';

const theme = {
  heroSlideshow: {
    speed: 5000,
    prevNextButtonsScale: '.3s',
    animateTransition: '2s',
    titleDelay: '1.3s',
    subtitleDelay: '1.3s',
    titleTransition: '.8s',
    subtitleTransition: '.8s',
    buttonDelay: '1.8s',
    buttonTransition: '.8s',
  },
};

const SectionHero = ({ smallHero, hero }) => {
  const section = hero && hero[0];
  const { pathname } = useLocation();

  // we have a hard coded hero section on home page
  if (pathname === '/') {
    return null;
  }

  // need a background placeholder for pages with empty heros
  if (!section) {
    return <div style={{ height: '174px' }} />;
  }

  return (
    <Hero
      smallHero={smallHero}
      key={section._key}
      backgroundImage={section?.backgroundImage?.asset?.gatsbyImageData}
      siteTitle={section.heroTitle}
      siteSubtitle={section.heroHeading}
    />
  );
};

export default SectionHero;
